import { useState } from 'react'
import { toInitials } from './initials.ts'
import styles from './Avatar.module.css'

export type AvatarSize = 'sm' | 'md' | 'lg'

export interface AvatarProps {
  src?: string
  alt?: string
  size?: AvatarSize
  /**
   * Shown when there is no image. Pass a NAME — it is condensed to initials.
   *
   * The prop used to render verbatim, so every caller that passed a name (most
   * of them: team names, gamer tags) got the whole string clipped inside the
   * circle. One or two characters are passed through untouched, so callers
   * that already supply initials are unaffected.
   */
  fallback?: string
  className?: string
}

export function Avatar({ src, alt, size = 'md', fallback, className }: AvatarProps) {
  const [failed, setFailed] = useState(false)

  const classes = [
    styles.avatar,
    styles[size],
    className,
  ].filter(Boolean).join(' ')

  if (!src || failed) {
    return (
      <div className={classes}>
        <span className={styles.fallback}>
          {fallback ? toInitials(fallback) : (alt?.charAt(0).toUpperCase() ?? '?')}
        </span>
      </div>
    )
  }

  return (
    <img
      src={src}
      alt={alt}
      className={classes}
      onError={() => setFailed(true)}
    />
  )
}
